import { render, staticRenderFns } from "./AssignAdminRoleDialog.vue?vue&type=template&id=c68b84dc&scoped=true"
import script from "./AssignAdminRoleDialog.vue?vue&type=script&lang=js"
export * from "./AssignAdminRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignAdminRoleDialog.vue?vue&type=style&index=0&id=c68b84dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68b84dc",
  null
  
)

export default component.exports